import { render, staticRenderFns } from "./base_animated_icon.vue?vue&type=template&id=c84959a4"
import script from "./base_animated_icon.vue?vue&type=script&lang=js"
export * from "./base_animated_icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports